import { CONTRACT_TYPES } from '@vy/types';
import { useFormContext } from 'react-hook-form';
import { useDialog } from '../../../../hooks/use-dialog';
import type { PlanInputForm } from '../../../../pages/plans/CreatePlanPage/create-plan-page-components/CreatePlanForm/create-plan-form-types/plan-input-form';
import { useGetContractPrerequisites } from '../../../../pages/plans/CreatePlanPage/create-plan-page-hooks/useGetContractPrerequisites';
import type { PlanCreationPlanPreview } from '../create-plan-provider-types/plan-creation-plan-preview';

export function usePlanCreationPlanPreview(): PlanCreationPlanPreview {
  const contractPrerequisites = useGetContractPrerequisites();
  const formContext = useFormContext<PlanInputForm>();

  const formValues = formContext ? formContext.getValues() : null;

  const isParentAgreement =
    contractPrerequisites?.contractType === CONTRACT_TYPES.ParentAgreement ||
    formValues?.contractType === CONTRACT_TYPES.ParentAgreement;

  const defaultPreviewState = !isParentAgreement;
  const { isDialogOpen, handleOpen, handleClose } = useDialog(defaultPreviewState);

  const handleShow = () => {
    handleOpen();
  };

  return {
    open: isDialogOpen && !isParentAgreement,
    show: handleShow,
    hide: handleClose,
  };
}
